import { Pipe, PipeTransform } from '@angular/core';
import { TStatementEvaluationStatus } from '../../../shared/models/scorecard-section.model';

@Pipe({
  name: 'statusLabel',
  standalone: true,
})
export class StatusLabelPipe implements PipeTransform {
  transform(value: TStatementEvaluationStatus): string {
    switch (value) {
      case 'fail':
        return EStatusLabel.no;
      case 'success':
        return EStatusLabel.yes;
      case 'unknown':
        return EStatusLabel.na;
      default:
        return EStatusLabel.error;
    }
  }
}

export enum EStatusLabel {
  no = 'No',
  yes = 'Yes',
  na = 'N/A',
  error = 'Error',
}
